export default "__VITE_ASSET__BbCiKpLj__"